import { Button, Input, Text } from '@thefarmersfront/kitchen';

import { DeliveryAreaRefineResultInfoArea } from '~/components/delivery-area/refine/DeliveryAreaRefineResultInfoArea';

import { useGetDeliveryTypeQuery } from '~/hooks/delivery-area';

import styles from './DeliveryAreaRefineResult.module.scss';

type DeliveryAreaRefineResultProps = {
  primaryAddress: string;
  zipCode: string;
  vendor: string;
  onReset: () => void;
};

const DeliveryAreaRefineResult = ({ primaryAddress, zipCode, vendor, onReset }: DeliveryAreaRefineResultProps) => {
  const { data: deliveryInfo } = useGetDeliveryTypeQuery({
    vendor,
    params: { zipCode, primaryAddress },
  });

  const getDescription = () => {
    if (!deliveryInfo) return '배송사 운영 정책에 따라 배송 유형 상세 안내가 제한됩니다.';
    if (deliveryInfo.deliverable && deliveryInfo.deliveryType) {
      return `${deliveryInfo.deliveryType.typeName} 지역입니다`;
    }
    return '배송 불가 지역입니다';
  };

  return (
    <>
      <div className={styles['input-section']}>
        <Text weight="semi-bold" element="span">
          배송지 주소 검색 결과
        </Text>
        <div className={styles['input-wrapper']}>
          <div className={styles['section-wrapper']}>
            <Text size="large" weight="semi-bold" className={styles['label']}>
              주소
            </Text>
            <Input
              type="text"
              size="small"
              value={primaryAddress}
              readOnly
              disabled={true}
              className={styles['address-input']}
            />
            <Button
              color="tertiary"
              onClick={onReset}
              variant="outlined"
              size="small"
              className={styles['action-button']}
            >
              재검색
            </Button>
          </div>
        </div>
      </div>

      <DeliveryAreaRefineResultInfoArea description={getDescription()} />
    </>
  );
};

export default DeliveryAreaRefineResult;
